module.exports = __webpack_public_path__ + "static/media/mutex_homepage.90fd9605.png";